import { useEffect } from 'react'
import BottomSheetContent from './BottomSheetContent'
import { trackEvent } from '../../utils/appBridge'
import { EventNames } from '../../types/misc.types'
import { getAppVersion } from '../../utils/sessionStorage'

export const ReturnsScoreHelpContent = ({ onDismiss }: { onDismiss: () => void }) => {
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        ScreenName: 'MF_L2_Elite',
        eventId: 'Returns_Score'
      }
    })
  }, [])
  return (
    <BottomSheetContent
      logoSrc='/images/mf-l2/returns-score-bottom-sheet.svg'
      heading={`${getAppVersion() >= 47 ? 'Consistency Score' : 'Returns Score'}`}
      onDismiss={onDismiss}
    >
      <div className='text-[#6A6E6E] text-[14px] font-[400]'>
        Shows how <span className='text-[#232323] text-[14px] font-[500]'> consistently </span> a fund has delivered
        high returns over time based on long-term data across market cycles.
        <br />
        <br />
        A higher score means it’s given high returns more consistently than other funds in its category.
        <br />
        <br /> Use this to assess the fund’s{' '}
        <span className='text-[#232323] text-[14px] font-[500]'> long-term track record. </span>
      </div>
    </BottomSheetContent>
  )
}
